const select = document.querySelector(".post-archive .categories-filter select");

if (select) {
  select.addEventListener("change", function (e) {
    window.location.href = select.value;
  });
}